import React, { useState } from "react";
import { Lock, ShieldCheck, KeyRound, Eye, EyeOff } from "lucide-react";
import { toast } from "react-toastify";

export default function ChangePassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);

  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
  e.preventDefault();

  const token = localStorage.getItem("membreToken");

  if (!token) {
    toast.error("Session expirée, reconnectez-vous.");
    return;
  }

  if (newPassword.length < 6) {
    toast.error("Le nouveau mot de passe doit contenir au moins 6 caractères.");
    return;
  }

  if (oldPassword === newPassword) {
    toast.error("Le nouveau mot de passe doit être différent de l'ancien.");
    return;
  }

  setLoading(true);

  try {
    const res = await fetch(
      "/api/membre?action=changePassword",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          oldPassword,
          newPassword,
        }),
      }
    );

    const data = await res.json();

    if (!data.success) {
      toast.error(
        data.message ||
        "Erreur lors du changement de mot de passe"
      );
      return;
    }

    toast.success("Mot de passe mis à jour !");

    setOldPassword("");
    setNewPassword("");

  } catch (err) {
    console.error(err);
    toast.error("Erreur réseau. Réessayez.");
  } finally {
    setLoading(false);
  }
}

  return (
    <div className="min-h-screen bg-gray-100 text-slate-900 px-4 py-8">
      <div className="max-w-xl mx-auto">

        
        <h1 className="text-3xl font-extrabold mb-6 text-center">
          Modifier mon mot de passe
        </h1>

        
        <div className="bg-white shadow-xl rounded-3xl p-8">

          
          <div className="flex justify-center mb-4">
            <div className="bg-blue-100 p-4 rounded-full shadow-lg flex items-center justify-center">
              <ShieldCheck size={36} className="text-blue-600" />
            </div>
          </div>

          <p className="text-center text-gray-600 mb-6">
            Pour sécuriser votre compte, utilisez un mot de passe fort et confidentiel.
          </p>

          
          <form onSubmit={handleSubmit} className="space-y-5" method="POST">

            
            <div className="flex items-center bg-gray-50 rounded-xl border px-4 py-3 gap-3 shadow-sm relative">
              <Lock size={20} className="text-blue-600" />

              <input
                type={showOld ? "text" : "password"}
                required
                placeholder="Ancien mot de passe"
                className="bg-transparent w-full outline-none"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />

              <button
                type="button"
                onClick={() => setShowOld(!showOld)}
                className="absolute right-3 text-gray-600"
              >
                {showOld ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            
            <div className="flex items-center bg-gray-50 rounded-xl border px-4 py-3 gap-3 shadow-sm relative">
              <KeyRound size={20} className="text-blue-600" />

              <input
                type={showNew ? "text" : "password"}
                required
                placeholder="Nouveau mot de passe"
                className="bg-transparent w-full outline-none"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />

              <button
                type="button"
                onClick={() => setShowNew(!showNew)}
                className="absolute right-3 text-gray-600"
              >
                {showNew ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            
            <button
              disabled={loading}
              className={`
                w-full py-3 rounded-xl text-white font-semibold shadow-lg transition
                ${loading ? "bg-blue-300" : "bg-blue-600 hover:bg-blue-700"}
              `}
            >
              {loading ? "Mise à jour…" : "Enregistrer le nouveau mot de passe"}
            </button>
          </form>

        </div>

      </div>
    </div>
  );
}
